import rules from './rules';

import type { RoleKey } from '@/types/rules';

const rbacCheck = (
  userRoles: RoleKey[] | undefined,
  action: string,
  data?: unknown
): boolean | string[] => {
  const permissions = userRoles?.[0] ? rules[userRoles[0]] : undefined;
  // Return FALSE if rules DO NOT include this role
  if (!permissions) return false;

  const staticPermissions = permissions.static;
  // Return TRUE if user has static permission for the specified action
  if (staticPermissions.includes(action)) return true;

  const dynamicPermissions = permissions.dynamic;
  // Return FALSE if dynamic rules DO NOT include the specified action
  const permissionCondition = dynamicPermissions[action as keyof typeof dynamicPermissions] as
    | ((data: unknown) => boolean)
    | undefined;
  if (typeof permissionCondition !== 'function') return false;
  // Return the function that will determine if user is entitled based on data param
  return permissionCondition(data);
};

export default rbacCheck;
